

























































































































































// TODO: Add validations for all fields

import { FormsApi, PatientApi } from "@/api";
import stateMixin from "@/mixins/state";
import { toLocalDateString } from "@/util/date";
import moment from "moment";

export default {
  data() {
    return {
      valid: true,
      toLocalDateString,
      time: null,

      dateTime: {
        date: null,
        time: null
      },

      autocomplete: {
        entries: [],
        isLoading: false,
        model: null,
        search: null,
        error: false
      },

      fields: {
        swallowDateTime: null,
        drugName: "",
        reasonOfRequest: ""
      },

      rules: {
        swallowDateTime: [v => !!v || "Sliktijd is verplicht"],
        drugName: [v => !!v || "Naam medicijn is verplicht"],
        reasonOfRequest: [v => !!v || "Reden aanvraag is verplicht"],
        patient: [v => !!v || "Patient is verplicht"],
        date: [v => !!v || "Datum is verplicht"],
        time: [v => !!v || "Tijd is verplicht"]
      },

      startDateMenu: null,
      startTimeMenu: null,
      sendDateMenu: null,
      receiveDateMenu: null
    };
  },
  name: "RequestPhoto",
  mixins: [stateMixin],
  methods: {
    submit: async function() {
      if (this.valid) {
        this.setState(this.states.LOADING);
        const api = new FormsApi();

        try {
          const result = await api.formsRequestPhoto({
            patientGender: "Male",
            patientId: this.autocomplete.model.patientId,
            patientBirthDate: this.autocomplete.model.birthDate,
            swallowDateTime: this.swallowDateTime,
            drugName: this.fields.drugName,
            reasonOfRequest: this.fields.reasonOfRequest
          });
          this.setState(this.states.COMPLETED);

          (this.$refs.form as HTMLFormElement).reset();
        } catch {
          this.setState(this.states.ERROR);
        }
      }
    }
  },
  computed: {
    currentDate() {
      let date = new Date(Date.now());
      return `${date.getFullYear()}-${`0${date.getMonth() + 1}`.slice(
        -2
      )}-${date.getDate()}`;
    },
    swallowDateTime() {
      let date = "";
      if (this.dateTime.date && this.dateTime.time) {
        date = new Date(`${this.dateTime.date} ${this.dateTime.time}`);
      }
      // return date;
      return date != "" ? moment(date).format() : "";
    }
  },
  watch: {
    "autocomplete.search": _.debounce(function(val) {
      if (!val) {
        return;
      }
      if (val.length < 2) {
        return;
      }

      let self = this;
      this.autocomplete.isLoading = true;
      this.autocomplete.error = true;

      const api = new PatientApi();
      api
        .patientSearchPatients({
          filter: val
        })
        .then(function(res) {
          self.autocomplete.entries = res.data;
          self.autocomplete.isLoading = false;
          self.autocomplete.error = false;
        })
        .catch(function(err) {
          self.autocomplete.isLoading = false;
          self.autocomplete.error = true;
        });
    }, 1000)
  }
};
